// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { bulkDeleteActivitiesRequestToJson, createActivityRequestToJson, createActivityResponseFromJson, deleteActivityRequestToJson, getActivityMetricsRequestToJson, getActivityMetricsResponseFromJson, getMultiActivityRequestToJson, getMultiActivityResponseFromJson, listActivitiesRequestToJson, listActivitiesResponseFromJson, listFieldOptionsRequestToJson, listFieldOptionsResponseFromJson, listFiltersRequestToJson, listFiltersResponseFromJson, restoreActivityRequestToJson, updateActivityRequestToJson, validateActivityRequestToJson, validateActivityResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createActivity(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/CreateActivity', createActivityRequestToJson(request));
    return createActivityResponseFromJson(raw);
}
export function createActivity$(request, options) {
    return defer(() => createActivityWithTransport$(getGlobalTransport(), request, options));
}
export function createActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/CreateActivity', createActivityRequestToJson(request), options)
        .pipe(map(resp => createActivityResponseFromJson(resp)));
}
export async function updateActivity(request) {
    await fetchRpc('crm.v1.CRMActivityService/UpdateActivity', updateActivityRequestToJson(request));
}
export function updateActivity$(request, options) {
    return defer(() => updateActivityWithTransport$(getGlobalTransport(), request, options));
}
export function updateActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/UpdateActivity', updateActivityRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiActivity(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/GetMultiActivity', getMultiActivityRequestToJson(request));
    return getMultiActivityResponseFromJson(raw);
}
export function getMultiActivity$(request, options) {
    return defer(() => getMultiActivityWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/GetMultiActivity', getMultiActivityRequestToJson(request), options)
        .pipe(map(resp => getMultiActivityResponseFromJson(resp)));
}
export async function listActivities(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/ListActivities', listActivitiesRequestToJson(request));
    return listActivitiesResponseFromJson(raw);
}
export function listActivities$(request, options) {
    return defer(() => listActivitiesWithTransport$(getGlobalTransport(), request, options));
}
export function listActivitiesWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/ListActivities', listActivitiesRequestToJson(request), options)
        .pipe(map(resp => listActivitiesResponseFromJson(resp)));
}
export async function listActivityFilters(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/ListActivityFilters', listFiltersRequestToJson(request));
    return listFiltersResponseFromJson(raw);
}
export function listActivityFilters$(request, options) {
    return defer(() => listActivityFiltersWithTransport$(getGlobalTransport(), request, options));
}
export function listActivityFiltersWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/ListActivityFilters', listFiltersRequestToJson(request), options)
        .pipe(map(resp => listFiltersResponseFromJson(resp)));
}
export async function deleteActivity(request) {
    await fetchRpc('crm.v1.CRMActivityService/DeleteActivity', deleteActivityRequestToJson(request));
}
export function deleteActivity$(request, options) {
    return defer(() => deleteActivityWithTransport$(getGlobalTransport(), request, options));
}
export function deleteActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/DeleteActivity', deleteActivityRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function restoreActivity(request) {
    await fetchRpc('crm.v1.CRMActivityService/RestoreActivity', restoreActivityRequestToJson(request));
}
export function restoreActivity$(request, options) {
    return defer(() => restoreActivityWithTransport$(getGlobalTransport(), request, options));
}
export function restoreActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/RestoreActivity', restoreActivityRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validateActivity(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/ValidateActivity', validateActivityRequestToJson(request));
    return validateActivityResponseFromJson(raw);
}
export function validateActivity$(request, options) {
    return defer(() => validateActivityWithTransport$(getGlobalTransport(), request, options));
}
export function validateActivityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/ValidateActivity', validateActivityRequestToJson(request), options)
        .pipe(map(resp => validateActivityResponseFromJson(resp)));
}
export async function listActivityFieldOptions(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/ListActivityFieldOptions', listFieldOptionsRequestToJson(request));
    return listFieldOptionsResponseFromJson(raw);
}
export function listActivityFieldOptions$(request, options) {
    return defer(() => listActivityFieldOptionsWithTransport$(getGlobalTransport(), request, options));
}
export function listActivityFieldOptionsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/ListActivityFieldOptions', listFieldOptionsRequestToJson(request), options)
        .pipe(map(resp => listFieldOptionsResponseFromJson(resp)));
}
export async function getActivityMetrics(request) {
    const raw = await fetchRpc('crm.v1.CRMActivityService/GetActivityMetrics', getActivityMetricsRequestToJson(request));
    return getActivityMetricsResponseFromJson(raw);
}
export function getActivityMetrics$(request, options) {
    return defer(() => getActivityMetricsWithTransport$(getGlobalTransport(), request, options));
}
export function getActivityMetricsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/GetActivityMetrics', getActivityMetricsRequestToJson(request), options)
        .pipe(map(resp => getActivityMetricsResponseFromJson(resp)));
}
export async function bulkDeleteActivities(request) {
    await fetchRpc('crm.v1.CRMActivityService/BulkDeleteActivities', bulkDeleteActivitiesRequestToJson(request));
}
export function bulkDeleteActivities$(request, options) {
    return defer(() => bulkDeleteActivitiesWithTransport$(getGlobalTransport(), request, options));
}
export function bulkDeleteActivitiesWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMActivityService/BulkDeleteActivities', bulkDeleteActivitiesRequestToJson(request), options)
        .pipe(map(() => undefined));
}
